export const SET_TOGGLE_MODAL_DELETE_SERVICE_TRIBUTES =
  'NFSE_TRIBUTES_COMPONENTS/SET_TOGGLE_MODAL_DELETE_SERVICE_TRIBUTES';
export const SET_MODAL_DELETE_SERVICE_TRIBUTES_IDS =
  'NFSE_TRIBUTES_COMPONENTS/SET_MODAL_DELETE_SERVICE_TRIBUTES_IDS';
